import React from "react";
import { useLanguage } from "../i18n/LanguageContext";
import "./LanguageSwitcher.css";

export default function LanguageSwitcher() {
  const { lang, setLang } = useLanguage();

  const toggleLanguage = () => {
    const nextLang = lang === "uk" ? "en" : "uk";
    setLang(nextLang);
    localStorage.setItem("lang", nextLang);
  };

  return (
    <button className="lang-switcher" onClick={toggleLanguage}>
      {lang === "uk" ? (
        <>
          <span className="flag">🇬🇧</span>
          <span className="code">EN</span>
        </>
      ) : (
        <>
          <span className="flag">🇺🇦</span>
          <span className="code">UA</span>
        </>
      )}
    </button>
  );
}
